/**
 * Public NCB reads for the blog.
 * Auth and cookie sessions are not part of the static site.
 */
const NCB_CONFIG = {
  conversationId: 'chat-23769dea-0dfa-48ce-9fc3-a9f9fdc15eab',
  proxyBase: 'https://rmvzorxcl35mttidiexhtp5g2m0hpsqo.lambda-url.us-east-2.on.aws',
  instance: '56398_konsulentbixen_blog_v2',
};

/**
 * @param {string} path - Endpoint path under public-data
 */
function buildPublicUrl(path) {
  const base = NCB_CONFIG.proxyBase.replace(/\/$/, '');
  const cleanPath = path.startsWith('/') ? path.substring(1) : path;
  const url = new URL(`${base}/ncb/${NCB_CONFIG.conversationId}/public-data/${cleanPath}`);
  url.searchParams.set('Instance', NCB_CONFIG.instance);
  url.searchParams.set('instance', NCB_CONFIG.instance);
  return url.toString();
}

/**
 * Uniform request handler for public NCB calls.
 */
async function ncbRequest(url, options = {}) {
  try {
    const res = await fetch(url, {
      headers: {
        'Content-Type': 'application/json',
        ...options.headers
      },
      ...options,
    });

    const body = await res.json().catch(() => ({}));

    if (!res.ok) {
      console.error(`NCB Error [${res.status}]:`, body);

      return {
        status: 'error',
        data: null,
        error: body?.message || body?.error || body?.details || `HTTP ${res.status}`,
        httpStatus: res.status,
        debug: body
      };
    }

    if (body && typeof body === 'object' && !Array.isArray(body) && body.status === 'success' && 'data' in body) {
      return body;
    }

    if (body && body.success === true && body.data) {
      return { status: 'success', data: body.data };
    }

    return { status: 'success', data: body };
  } catch (err) {
    console.error('NCB Network/Fetch Error:', err);
    return { status: 'error', data: null, error: err?.message || 'Network error' };
  }
}

/**
 * Public Data endpoints: GET to /ncb/<id>/public-data/<path>
 */
export async function publicDataFetch(path, options = {}) {
  return ncbRequest(buildPublicUrl(path), options);
}

export const TABLES = {
  POSTS: 'posts_1781605539',
  AUTHORS: 'authors_1781605539',
  CATEGORIES: 'categories_1781605539',
  TAGS: 'tags_1781605539',
  MEDIA: 'media_1781605539',
  REDIRECTS: 'redirects_1781605539',
  EXTERNAL_ANALYSES: 'external_analyses_1781605539',
  REVISIONS: 'revisions_1781605539'
};
